import React from 'react';

const clampOpacity = (value) => {
  const parsed = Number(value);
  if (!Number.isFinite(parsed)) return 0.35;
  return Math.min(1, Math.max(0.15, parsed));
};

const ProfileFooter = ({ opacity = 0.35, username, onOpenUtility, color }) => {
  const footerOpacity = clampOpacity(opacity);
  const hoverOpacity = Math.min(1, footerOpacity + 0.25);
  const source = username ? `profile_${encodeURIComponent(username)}` : 'profile_footer';
  const homeHref = `https://linkit-tan.vercel.app?utm_source=${source}&utm_medium=public_profile&utm_campaign=profile_footer`;
  const Element = onOpenUtility ? 'button' : 'a';
  const actionProps = onOpenUtility
    ? { type: 'button', onClick: onOpenUtility }
    : { href: homeHref, target: '_blank', rel: 'noopener noreferrer' };

  return (
    <footer className="w-full py-8 flex items-center justify-center px-6 text-center" style={color ? { color } : undefined}>
      <Element
        {...actionProps}
        className="text-[10px] font-bold text-current transition-opacity duration-300"
        style={{ opacity: footerOpacity }}
        onMouseEnter={(event) => { event.currentTarget.style.opacity = hoverOpacity; }}
        onMouseLeave={(event) => { event.currentTarget.style.opacity = footerOpacity; }}
      >
        Made with Linkit
      </Element>
    </footer>
  );
};

export default ProfileFooter;
